/**
 * 浏览器环境常量
 */
import { getQueryString } from '@/commons/utils/index';

export enum EnvType {
    Wx,
    WxWork,
    Web,
}

/**
 * 微信常用工具
 */
class WxUtils {
    /**
     * 获取当前浏览器的环境
     * 一般浏览器/微信/企业微信
     */
    public getEnv(): EnvType {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.includes('wxwork')) {
            return EnvType.WxWork;
        } else if (ua.includes('micromessenger')) {
            return EnvType.Wx;
        } else {
            return EnvType.Web;
        }
    }

    /**
     * 获取code
     */
    public getCode(): string | null {
        return getQueryString('code');
    }
}
const wxUtils = new WxUtils();
export default wxUtils;
